import { ApplicationMenuContext as e } from "./ApplicationMenuContext.js";
import { c as t } from "react/compiler-runtime";
import { useContext as n, useSyncExternalStore as r } from "react";
//#region src/components/ApplicationMenu/useGetRegisteredMenuItems.ts
var i = [];
function a(a) {
	let s = t(6), c = n(e), l;
	s[0] !== a || s[1] !== c ? (l = (e) => c?.subscribe(a, e) ?? o, s[0] = a, s[1] = c, s[2] = l) : l = s[2];
	let u = l, d;
	s[3] !== a || s[4] !== c ? (d = () => c?.getItems(a) ?? i, s[3] = a, s[4] = c, s[5] = d) : d = s[5];
	let f = d;
	return r(u, f, f);
}
function o() {}
//#endregion
export { a as useGetRegisteredMenuItems };
